import { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, Button, Input, Textarea } from '../../../components/ui';

export default function BookSeriesNew({ series = {} }) {
  const [name, setName] = useState(series.name || '');
  const [author, setAuthor] = useState(series.author || '');
  const [description, setDescription] = useState(series.description || '');
  const [saving, setSaving] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true);
    router.post(
      '/teacher/book_series',
      { book_series: { name: name.trim(), author: author.trim() || null, description: description.trim() || null } },
      { onFinish: () => setSaving(false) }
    );
  };

  return (
    <TeacherShell scrollTitle="New Series">
      <TeacherPageHeader
        title="New Series"
        backLink="/teacher/book_series"
        backLabel="Series"
      />

      <div className="max-w-lg">
        <Card className="p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Name <span className="text-red-500">*</span>
              </label>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Harry Potter"
                required
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Author
              </label>
              <Input
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                placeholder="Optional — useful when every book shares an author"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Description
              </label>
              <Textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
                placeholder="Optional"
              />
            </div>

            <div className="flex items-center gap-3 pt-1">
              <Button type="submit" disabled={saving || !name.trim()}>
                {saving ? 'Creating…' : 'Create series'}
              </Button>
              <Link href="/teacher/book_series">
                <Button type="button" variant="secondary">Cancel</Button>
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </TeacherShell>
  );
}
